import { render, staticRenderFns } from "./IncomeEmployment.vue?vue&type=template&id=f4b1c402&"
import script from "./IncomeEmployment.vue?vue&type=script&lang=js&"
export * from "./IncomeEmployment.vue?vue&type=script&lang=js&"
import style0 from "./IncomeEmployment.vue?vue&type=style&index=0&id=f4b1c402&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports